import {ref} from "vue";
import {defaultFetch, httpMethod} from "@/scripts/Common/api";
import type {CardLimite} from "@/components/settings/scripts/CardLimite";
import {getToken} from "@/scripts/Common";

const cardLimite = ref<CardLimite>({
  maxCardLimit: 250,
  maxMonthlyTopUpAmount: 50,
  topUpLimitPerMonth: 250,
  minCardLimit: 0
});
const responseError = ref<any>();

const loadCardLimite = async () => {
  const {
    error,
    response,
  } = await defaultFetch({
    apiName: 'cardLimiteConfiguration',
    bearer: getToken(),
    options: {
      method: httpMethod.GET,
    }
  });

  cardLimite.value = response;
  responseError.value = error;
}

const useCardLimites = () => {
  loadCardLimite();

  return {
    cardLimite,
    error: responseError,
  }
}

export {
  useCardLimites
}
